/** Qatari mobiles are 8 digits beginning 3, 5, 6 or 7. Accepts the four ways
 *  a person writes their own number and produces the one shape the rest of the
 *  system stores. */
export function toE164Qatar(input: string): string | null {
  const digits = input.replace(/[^\d]/g, "").replace(/^0+/, "");
  const local = digits.startsWith("974") ? digits.slice(3) : digits;
  if (!/^[3567]\d{7}$/.test(local)) return null;
  return `+974${local}`;
}
